import AlarmEventsTable from "./AlarmEventsTable";

export default AlarmEventsTable